// extracted by mini-css-extract-plugin
export default {"section":"AccuracyAnalysis_section__mVdDA"};